// extracted by mini-css-extract-plugin
export default {"footer-card":"FooterCard_footer-card__i0VgS","footer-info":"FooterCard_footer-info__MlM-k"};